import React from 'react';
import styled from 'styled-components';
import { useFormikContext } from 'formik';

import TimeRangeDisplay from 'views/components/searchbar/time-range-filter/TimeRangeDisplay';
import TimeRangeSelectInput from 'data-lake/components/TimeRangeSelectInput';
import type { DataLakeActionFormValues } from 'data-lake/Types';

const StyledP = styled.p`
  margin-top: 10px;
  font-weight: bold;
`;

type Props = {
  submitButtonText: string;
  hourOnly: boolean;
};

const TimeRangeField = ({ submitButtonText, hourOnly }: Props) => {
  const {
    values: { nextTimeRange },
  } = useFormikContext<DataLakeActionFormValues>();

  return (
    <>
      <StyledP>Time Range: </StyledP>
      <p>Please select a time range and click {submitButtonText}.</p>
      <TimeRangeDisplay timerange={nextTimeRange} />
      <TimeRangeSelectInput timerange={nextTimeRange} disableTimeMinute={hourOnly} disableTimeSecond={hourOnly} />
    </>
  );
};

export default TimeRangeField;
